import { FC } from "react";
import { Menu } from "@headlessui/react";
import CheckIcon from "@heroicons/react/outline/CheckIcon";
import { useRouter } from "next/router";

import FilterMenu from "./filter-menu";

import { ActionType, SetRemoveStringValueType } from "@interfaces/filters";
import { useFilters } from "@context/filter";
import { classNames } from "@utils/class-names";

interface Props {
  filterName: string;
  type: SetRemoveStringValueType;
  entries: Record<string, Record<string, string | number>>;
  className?: string;
  check?: boolean;
}

const GridFilter: FC<Props> = ({
  type,
  entries,
  filterName,
  className,
  check,
}) => {
  const { filters, dispatch } = useFilters();
  const { locale } = useRouter();

  let value: Set<string>;

  switch (type) {
    case ActionType.SET_MATERIAL:
      value = filters.materialSet;
      break;
    case ActionType.SET_STYLE:
      value = filters.stylesSet;
      break;
    case ActionType.SET_AREA:
      value = filters.areasSet;
      break;
    case ActionType.SET_COLOR:
      value = filters.colorSet;
      break;
    case ActionType.SET_SUPPLIER:
    default:
      value = filters.suppliersSet;
      break;
  }

  const options = Object.keys(entries);

  return (
    <FilterMenu {...{ text: filterName, className }}>
      {options &&
        !!options.length &&
        options.map((name) => (
          <Menu.Item key={name} disabled={value.has(name)}>
            {({ active, disabled }) => (
              <button
                className={classNames(
                  "grid grid-cols-12 gap-1 p-4 min-w-[8rem] transition-all duration-200",
                  active ? " bg-gray-400" : "",
                  disabled ? " text-gray-400" : "",
                  options.length > 2
                    ? "w-1/3"
                    : options.length > 1
                    ? "w-1/2"
                    : "w-full"
                )}
                onClick={() => dispatch({ type, value: name })}
              >
                <div className="flex justify-center items-center w-full">
                  <div
                    className="col-span-2 rounded-full border-2 border-gray-200 min-w-[1rem] min-h-[1rem] flex justify-center items-center"
                    style={{
                      backgroundColor: filterName === "Color" ? name : "white",
                    }}
                  >
                    {!!check && disabled && (
                      <CheckIcon className="text-black absolute w-8 h-8" />
                    )}
                  </div>
                </div>
                <span className="col-span-10 relative w-full grid grid-cols-12 gap-2 text-sm capitalize">
                  <span className="col-span-10">
                    {locale ? entries[name][locale] : name}
                  </span>
                  <span
                    className={classNames(
                      "font-light text-xs align-bottom col-span-2",
                      active ? "text-black" : "text-gray-400"
                    )}
                  >
                    ({entries[name]["count"]})
                  </span>
                </span>
              </button>
            )}
          </Menu.Item>
        ))}
    </FilterMenu>
  );
};

export default GridFilter;
